import { render, staticRenderFns } from "./Rights.vue?vue&type=template&id=9b039b8a"
import script from "./Rights.vue?vue&type=script&lang=js"
export * from "./Rights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports